/**
 * Splits a source array into two array containing items that respectively do and do not fulfil a certain condition
 * @param {any[]} source The source array
 * @param filterCondition An arrow function that checks for a certain condition
 */
export function splitFilter(source: any[], filterCondition: (value: any) => boolean): [any[], any[]] {
    return source.reduce(
        (splitList, current) => {
            if (filterCondition(current)) {
                splitList[0].push(current);
                return splitList;
            } else {
                splitList[1].push(current);
                return splitList;
            }
        },
        [[], []]
    );
}
